import React, { useState, useCallback } from 'react';
import TcgCardTable from '../components/TcgReference/TcgCardTable';
import TcgPopulateButton from '../components/TcgReference/TcgPopulateButton';
import { useTcgCards } from '../hooks/useTcgCards';
import { useTcgPopulate } from '../hooks/useTcgPopulate';
import { useAuth } from '../context/AuthContext';
import { tcgApi } from '../api/client';

export default function TcgReferencePage() {
  const { user } = useAuth();
  const isAdmin = user?.is_admin || user?.is_super_admin;
  const cardState = useTcgCards();
  const { populating, status, error: popError, startPopulate } =
    useTcgPopulate(cardState.refresh);

  const [resetting, setResetting] = useState(false);
  const [resetError, setResetError] = useState(null);

  const startResetAndRepopulate = useCallback(async () => {
    if (!window.confirm('This will delete ALL TCG reference data (sets and cards) and repopulate from Limitless TCG. Continue?')) {
      return;
    }
    setResetting(true);
    setResetError(null);
    try {
      await tcgApi.reset();
      // After reset, start populate
      setResetting(false);
      startPopulate();
    } catch (err) {
      setResetting(false);
      setResetError(err.response?.data?.detail || 'Failed to reset TCG database');
    }
  }, [startPopulate]);

  return (
    <div className="dashboard-page">
      <div className="dashboard-header">
        <h2>TCG Card Reference</h2>
        {isAdmin && (
          <TcgPopulateButton
            onPopulate={startPopulate}
            populating={populating}
            status={status}
            onReset={startResetAndRepopulate}
            resetting={resetting}
          />
        )}
      </div>

      {popError && <div className="error-message">{popError}</div>}
      {resetError && <div className="error-message">{resetError}</div>}

      <TcgCardTable {...cardState} />
    </div>
  );
}
